import {
  ChangeDetectorRef,
  Directive,
  EventEmitter,
  inject,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FieldDef } from '@core/models';
import { RelatedToType } from '@shared/enums';
import { BehaviorSubject } from 'rxjs';
import { TsComponent } from '../ts.component';
import { Entity } from '../../types';
import { FormFieldComponent } from '@shared/components/form-fields/form-field.component';
import { DataUpdatedArgs, EditToggle, JupiterPanelDef, Origin } from './types';

@Directive()
export class JupiterPanelComponent<T, D = any> extends TsComponent {
  @ViewChildren('formFields') formFields: QueryList<FormFieldComponent>;

  changeDetectorRef = inject(ChangeDetectorRef);

  @Input({ required: true }) panelDef: JupiterPanelDef<T>;
  @Input() fieldDefs: FieldDef[];
  @Input({ required: true }) model: Entity;
  @Input() data: any;
  @Input({ required: true }) relatedTo: RelatedToType;
  @Output() panelDefUpdated = new EventEmitter<JupiterPanelDef<T>>();
  @Output() dataUpdated = new EventEmitter<DataUpdatedArgs<T, D>>();
  @Output() editToggled = new EventEmitter<EditToggle<T>>();
  @Output() discardClicked = new EventEmitter<Origin<T>>();

  panelDefMemento: JupiterPanelDef<T>;
  modelMemento: any;
  touched = new BehaviorSubject(false);
  isBusy = new BehaviorSubject(false);
  editMode = new BehaviorSubject(false);

  ngOnInit(): void {
    this.panelDefMemento = JSON.parse(JSON.stringify(this.panelDef));
    this.modelMemento = JSON.parse(JSON.stringify(this.model));
  }

  lookupField(name: string): FieldDef {
    return this.fieldDefs.find((fieldDef) => fieldDef.name == name);
  }

  onSaveLayout(): void {
    this.panelDefUpdated.emit(this.panelDef);
    this.panelDefMemento = JSON.parse(JSON.stringify(this.panelDef));
    this.editToggled.emit({ toggle: false, origin: this.panelDef });
    this.editMode.next(false);
  }

  onCancelEditLayout(): void {
    this.panelDef = JSON.parse(JSON.stringify(this.panelDefMemento));
    this.editToggled.emit({ toggle: false, origin: this.panelDef });
    this.editMode.next(false);
  }

  onStartEditLayout(): void {
    this.editToggled.emit({ toggle: true, origin: this.panelDef });
    this.editMode.next(true);
  }

  discardChanges(): void {
    this.model = { ...this.modelMemento };
    this.touched.next(false);
    this.discardClicked.emit({ origin: this.panelDef });
  }

  saveChanges(): void {
    this.dataUpdated.emit({ model: this.model, origin: this.panelDef });
    this.editMode.next(false);
  }
}
